function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.99 35.76l-4.26.98s-5.91 9.12-7.2 18.82c-.81 6.09-.84 14.04-.28 18c.57 3.96 2.61 12.39 5.82 18.33c3.09 5.72 6.1 7.97 9.39 9.96c1.41.85 2.67 3.76 4.87 5.17c2.06 1.32 4.78 1.58 4.78 1.58s7.52 11.81 23.79 13.86c19.09 2.4 28.43-6.22 28.43-6.22s7.64-.02 14.85-3.11c8.09-3.47 12.41-10.69 12.41-10.69s10.13-8.72 13.34-19.16c2.58-8.38 2.65-24.31.67-31.81s-5.81-13.85-8.85-17.92c-2.42-3.24-29.44-17.6-32.7-18.88c-3.25-1.27-33.52-3.25-34.65-2.4c-1.13.86-30.41 23.49-30.41 23.49z",
  fill: "#ac5811"
});

var _ref3 = /*#__PURE__*/React.createElement("radialGradient", {
  id: "IconifyId17ecdb2904d178eab6390",
  cx: 64.164,
  cy: 57.596,
  r: 53.202,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.507,
  stopColor: "#f29f58"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.715,
  stopColor: "#f09d56"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.826,
  stopColor: "#eb9550"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.914,
  stopColor: "#e18745"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.99,
  stopColor: "#d47436"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#d27133"
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M26.53 19.75c-7.05 5.74-10.7 8.74-14.36 15.92S9.69 52.38 10.35 55.9c.65 3.52 1.83 10.31 2.48 13.7c.65 3.4 2.38 11.46 7.17 16.45c6.71 6.99 12.79 9.4 12.79 9.4s4.93 7.64 16.84 12.01c15.66 5.74 22.71-2.61 28.71-4.83s13.18-2.35 19.32-6.66c6.13-4.31 12.92-9.53 17.36-20.49s3.52-15.79 3.65-18.53c.13-2.74-.26-15.92-5.35-24.01s-11.21-12.95-13.57-14.49C94.53 15.06 75.89 6.95 71.2 6.04c-4.7-.91-21.46.51-28.11 3.25S26.53 19.75 26.53 19.75z",
  fill: "url(#IconifyId17ecdb2904d178eab6390)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M56.28 71.46c-1.11-.35-2.28-2-2.56-5.53c-.39-5.03 3.32-6.42 3.32-6.42s4.42-1.17 7.53-2.28c2.89-1.03 4.97-2.35 4.97-2.35s.28-5.39 2.07-6.98c1.8-1.59 4.97-1.45 8.5-1.04c3.52.41 9.19 2.76 8.36 4.9c-.83 2.14-1.8 4.28-5.18 6.22c-3.38 1.93-5.8 3.73-7.53 5.25c-1.73 1.53-4.9 3.45-10.15 5.39s-7.73 3.34-9.33 2.84z",
  fill: "#ffc86e"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M26.55 26.47c-3.32-.68-8.01 6.51-8.88 8.89c-.88 2.38-1.78 8.18-1.88 10.83c-.13 3.29-.19 6.38 1.19 8.89c1.06 1.94 3.63 3.03 5.94 1.03c2.31-2 6.32-7.48 7.38-8.25s4.16-1.79 2.94-6.83c-.5-2.06-5.57-6.32-5.82-6.9c-.24-.57 1.01-7.27-.87-7.66z",
  fill: "#ffc86e"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M50.02 17.44c.13 1.93 1.71 5.02 3.42 6.69c2.56 2.49 14.3 10.91 17.34 10.43s6.35-5.94 7.32-7.46s2.9-3.66 3.66-4.63c.76-.97 2.76-3.18 1.11-5.39c-1.66-2.21-5.8-3.66-8.56-3.87c-2.76-.21-7.05-2-10.71-1.86c-3.66.14-13.92 1.11-13.58 6.09z",
  fill: "#ffc86e"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M98.34 43.19c.23 2.1 3.18 2.56 5.53 4.08s3.94 3.11 5.32 2.69c1.38-.41 3.26-2.62 2.83-6.49c-.55-4.97-3.66-11.33-8.01-11.12c-2.63.13-2.27 4.7-2.27 4.7s-3.54 4.9-3.4 6.14z",
  fill: "#ffc86e"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M41.47 30.23s-9.43-.06-9.26.88c.18.94 1 4.04 3.46 4.16c2.46.12 5.63.35 7.15-.12c1.52-.47 5.74-3.87 5.74-5.39s-1.7-3.75-1.7-3.75l-5.39 4.22z",
  fill: "#cf701e"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M54.94 47.52s-.11.07-.27.2c-.47.39-1.37 1.3-1.02 2.32c.47 1.35 3.22 3.87 5.92 3.87s4.16-2.52 4.63-4.16c.47-1.64.23-2.64.23-2.64l-9.49.41z",
  fill: "#cf701e"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M33.91 55.2s-1.64.59-1.58 1.64c.06 1.05.47 2.99 2.58 5.04c2.13 2.07 5.22 2.64 8.03 1.88c2.81-.76 4.86-2.87 4.63-5.68c-.23-2.81-2.93-4.98-2.93-4.98l-10.73 2.1z",
  fill: "#cf701e"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M21.78 70.73s-1.76.41-1.58 1.58s2.17 4.86 5.33 4.45s8.15-4.04 8.15-5.45s-2.52-3.28-2.52-3.28l-9.38 2.7z",
  fill: "#cf701e"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M43.34 85.38s-.65 3.78 4.45 5.16c8.5 2.29 9.38-2.87 9.38-2.87l-13.83-2.29z",
  fill: "#cf701e"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M76.73 87.13s-2.28 2.28.31 4.07c2.59 1.79 5.54 2.4 8.32 2.09s4.68-2.53 4.68-2.53l-13.31-3.63z",
  fill: "#cf701e"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M98.01 61.81s-4.3 2.17-.97 5.92c2.53 2.86 8.32 2.28 10.69.67c1.55-1.05 2.01-2.91 1.43-3.85c-.59-.94-11.15-2.74-11.15-2.74z",
  fill: "#cf701e"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M81.37 36.97s-.23 4.91 6.39 4.75c9.26-.23 8.09-5.98 8.09-5.98l-14.48 1.23z",
  fill: "#cf701e"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M85.65 30.82s-4.34 2.7-4.81 3.81c-.47 1.11-1.47 4.63 3.57 4.4c5.04-.23 10.08-.41 11.78-2.46c1.7-2.05 1.29-3.93.59-5.45s-4.64-7.27-7.77-7.2c-2.05.04-3.36 6.9-3.36 6.9z",
  fill: "#593329"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M88.99 23.9s-2.75-.35-5.16 3.93c-2.4 4.28-3.02 6.83-3.02 6.83s4.89.02 7.82-.33c2.93-.35 4.92-2.17 4.92-2.17s-2.39-7.73-4.56-8.26z",
  fill: "#925849"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M55.71 43.89s-2.4-.16-2.58.77c-.18.94.35 3.33 1.17 4.38s3.28 3.4 5.74 2.93c2.46-.47 3.92-2.88 4.33-3.71c.37-.78.77-1.62.07-2.67c-.71-1.06-8.73-1.7-8.73-1.7z",
  fill: "#593329"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M59.28 40.14c-2.04-.22-6.96 3.69-6.08 5.03c.98 1.47 1.15.54 3.85 1.89c2.23 1.11 3.2 2.14 4.6 1.96s3.07-2.49 2.78-3.43c-.29-.94-2.39-5.16-5.15-5.45z",
  fill: "#925849"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M36.19 24.31l-4.8 3.32s-.18 2.25.82 3.48s1.29 1.99 5.98 1.99s9.08-.64 9.9-3.98c.82-3.34-.62-5.48-1.5-6.71c-.88-1.23-10.4 1.9-10.4 1.9z",
  fill: "#593329"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M36.25 19.1c-1.08.46-3.63 3.93-4.22 5.45c-.59 1.52-.72 3.14-.64 3.16c.97.24 6.68.77 9.2.36c2.52-.41 4.57-1.52 5.39-2.99c.65-1.17.6-2.72.6-2.72s-1.71-3.08-4.06-4.02c-2.34-.94-5.86.58-6.27.76z",
  fill: "#925949"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M32.23 55.42s-.4.61.36 1.78s2.25 2.57 4.48 3.22c2.23.64 3.81 1.52 5.27 1.35c1.47-.18 4.34-1.35 4.45-5.39c.12-4.04-.7-5.92-2.46-7.68s-3.03-1.46-3.03-1.46l-9.07 8.18z",
  fill: "#593329"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M32.74 51.68c-.62 1.04-1.08 4.42-.32 5.18c.76.76 5.33.81 6.53.68c1.21-.13 5.16-1.99 5.22-3.4c.06-1.41-.7-3.28-.7-3.98s.88-2.34-1.52-2.93s-7.93 2.28-9.21 4.45z",
  fill: "#925849"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M24.82 66.86s-3.77.93-4.01 2.22c-.23 1.29.31 2.59 1.6 3.82s2.23 2.52 3.22 2.4c1-.12 3.63-2.46 4.45-3.22c.82-.76 1.99-2.11 1.88-3.22s-.59-2.23-1.64-3.11c-1.04-.88-5.5 1.11-5.5 1.11z",
  fill: "#593329"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M25.76 63.52c-1.76.04-3.11 2.17-3.69 2.93c-.59.76-1.58 2.58-1.17 2.87c.41.29 2.11.47 2.93 1c.82.53 2.05 1.35 2.99.59c.94-.76 1.76-2.87 2.23-3.57c.47-.7 1.29-1.58 1.29-1.58s-1.77-2.3-4.58-2.24z",
  fill: "#925849"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M47.27 77.64c-.35.41-5.33 4.45-5.33 4.45s.18 3.52 1.29 4.34c1.11.82 4.57 1.99 6.8 2.46c2.23.47 6.21 1 7.21.59c1-.41 2.05-2.58 2.11-5.39c.06-2.81-.94-4.91-2.05-6.2c-1.11-1.29-2-1.77-2-1.77l-8.03 1.52z",
  fill: "#593329"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M53.89 82.91c.65-.73 1.41-6.8 1.41-6.8s-4.51-3.46-6.39-3.69c-1.88-.23-4.1-.06-4.75.64c-.64.7-3.16 3.22-2.93 4.86s.7 4.16.7 4.16s10.61 2.36 11.96.83z",
  fill: "#925849"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M75.75 85.8s-.57 3.8 3.61 4.52c4.18.71 7.65 1.66 9.46 1.28c1.81-.38 3.61-2.8 3.8-4.56c.19-1.76.29-4.3 0-4.99c-.76-1.83-4.28-6.84-5.99-7.37c-.96-.29-1.87-.13-1.87-.13L75.75 85.8z",
  fill: "#593329"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M78.46 79.14c-1.87 2.07-2.83 5.06-2.73 6.64c.1 1.49 7.19.84 8.03.33c.84-.51 2.67-2.79 2.73-3.55s-.52-3.14-.62-4.61c-.1-1.47-.14-3.47-.95-3.42c-.81.05-3.8 1.67-6.46 4.61z",
  fill: "#925849"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M102.44 53.34s1.65.24 3.68 1.46c2.37 1.42 4.85 5.04 4.66 7.99s-2.76 4.28-5.89 4.33s-6.19-.12-6.76-1.74c-.57-1.62 4.31-12.04 4.31-12.04z",
  fill: "#593329"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M99.94 54.33c-.49.68-1.76 2.76-2.19 5.42s-.14 5.7.81 6.23c.95.52 6.18-3.99 6.46-4.47c.29-.48-1.67-7.75-2.29-8.08s-2.17.05-2.79.9z",
  fill: "#925849"
});

function SvgCookie(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--noto",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCookie);
export default __webpack_public_path__ + "static/media/cookie.7afc92f884f824e0ead11316edd9e80a.svg";
export { ForwardRef as ReactComponent };